module.exports = __webpack_public_path__ + "static/media/replit_ai.13c9af7c.png";